import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { Lang } from '@/stores/locale';
import { useLocaleStore } from '@/stores/locale';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const LABELS: Record<Lang, string> = { en: 'English', 'zh-CN': '中文' };

export function LangSwitch() {
  const { t } = useTranslation();
  const lang = useLocaleStore((s) => s.lang);
  const setLang = useLocaleStore((s) => s.setLang);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t('nav.language')} title={LABELS[lang]}>
          <Globe />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-32">
        <DropdownMenuRadioGroup value={lang} onValueChange={(v) => setLang(v as Lang)}>
          <DropdownMenuRadioItem value="en">{LABELS.en}</DropdownMenuRadioItem>
          <DropdownMenuRadioItem value="zh-CN">{LABELS['zh-CN']}</DropdownMenuRadioItem>
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
